export default __webpack_public_path__ + "static/media/gallery-s-1.05404a32.png";